import { ApiRequestFilters } from './api-request-filters';

/**
 * Api request
 */
export class ApiRequest {
	/*
	 * The filters to apply to the request
	 */
	filters?: ApiRequestFilters;
}
